import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
const HelloWorld = resolve => require(['@/components/HelloWorld'], resolve);
const Login = resolve => require(['@/pages/Login'], resolve);
const principalLogin = resolve => require(['@/pages/principalLogin'], resolve);
const bindUserLogin = resolve => require(['@/pages/bindUserLogin'], resolve);
const privacyPolicy = resolve => require(['@/pages/privacyPolicy'], resolve);
const userAgreement = resolve => require(['@/pages/userAgreement'], resolve);
const createQrcode = resolve => require(['@/pages/createQrcode'], resolve);
const appXiazai = resolve => require(['@/pages/appXiazai'], resolve);

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/principalLogin',
      name: 'principalLogin',
      component: principalLogin
    },
    {
      path: '/createQrcode',
      name: 'createQrcode',
      component: createQrcode
    },
    {
      path: '/appXiazai',
      name: 'appXiazai',
      component: appXiazai
    },
    {
      path: '/bindUserLogin',
      name: 'bindUserLogin',
      component: bindUserLogin
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement
    },

    {
      path: '/outCust',
      name: 'outCust',
      "title": "外部客户首页",
      meta: {
        widthOutAny: true
      },
      component: resolve =>
        require(["@/pages/outCustIndex/outCust.vue"], resolve)
      },
    {
      path: '/outCustShop',
      name: 'outCustShop',
      "title": "外部客户店铺首页",
      meta: {
        widthOutAny: true
      },
      component: resolve =>
        require(["@/pages/outCustIndex/outCustShop.vue"], resolve)
    },
    {
      path: '/salesList',
      name: 'salesList',
      "title": "购买历史",
      meta: {
        keepAlive: true,
        widthOutAny: true
      },
      component: resolve =>
        require(["@/pages/outCust/salesList.vue"], resolve)
    },{
      path: '/fenxiang_customerAnalysis',
      name: 'fenxiang_customerAnalysis',
      "title": "客户分析",
      meta: {
        keepAlive: true,
        widthOutAny: true
      },
      component: resolve =>
        require(["@/pages/outCust/fenxiang_customerAnalysis.vue"], resolve)
    },
    {
      path: '/salesListDetails',
      name: 'salesListDetails',
      "title": "购买历史",
      meta: {
        widthOutAny: true
      },
      component: resolve =>
        require(["@/pages/outCust/salesListDetails.vue"], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js